import type { ReactElement } from 'react';

import type { Quote } from '@core/types/api/Quote/Quote';

import { PdfTextBlock, type PdfTextBlockProps } from '../../components/PdfTextBlock';

type PdfNotesProps = {
  quote: Quote;
  /** @default 12 */
  fontSize?: number;
  textBlockProps?: Omit<PdfTextBlockProps, 'content'>;
};

export const PdfNotes = ({ quote, fontSize = 12, textBlockProps }: PdfNotesProps): ReactElement => (
  <PdfTextBlock
    content={quote.terms ?? ' '}
    textStyle={{
      fontSize,
    }}
    {...textBlockProps}
  />
);
